import { Button, Chip, Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@prelude-ai/design-system"
import { Wrench } from "lucide-react"
import type { ToolMetadata } from "../../types/index.ts"

type ToolsDrawerProps = {
  tools: ToolMetadata[] | undefined
  agentName: string
}

export default function ToolsDrawer({ tools, agentName }: ToolsDrawerProps) {
  if (!tools || tools.length === 0) return null

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" size="sm">
          <Wrench className="h-4 w-4 mr-2" />
          Tools ({tools.length})
        </Button>
      </SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Available Tools for {agentName}</SheetTitle>
        </SheetHeader>
        <div className="mt-4 px-4 space-y-3 overflow-y-auto max-h-[calc(100vh-120px)]">
          {tools.map((tool) => (
            <div key={tool.name} className="p-3 rounded-md bg-muted">
              <div className="font-medium text-sm">{tool.name}</div>
              <div className="text-xs text-muted-foreground mt-1">{tool.description}</div>
              {tool.parameters && tool.parameters.length > 0 && (
                <div className="mt-2 pt-2 border-t border-border/50">
                  <div className="text-xs font-medium text-muted-foreground mb-1">Parameters</div>
                  <div className="space-y-2">
                    {tool.parameters.map((param) => (
                      <div key={param.name} className="text-xs">
                        <div className="flex flex-wrap items-center gap-1">
                          <code className="text-cyan-500 font-mono">{param.name}</code>
                          <Chip className="text-[10px] px-1 py-0">{param.type}</Chip>
                          {param.required && (
                            <Chip variant="destructive" className="text-[10px] px-1 py-0">
                              required
                            </Chip>
                          )}
                        </div>
                        {param.description && (
                          <div className="text-muted-foreground mt-0.5 wrap-break-words">{param.description}</div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  )
}
